<template>
  <v-layout column wrap>
    <v-flex xs12 sm6 >
      <v-date-picker
        ref="picker"
        v-model="date"
        show-current
        reactive
        :picker-date.sync="pickerDate"
        header-color="primary"
        :full-width="fullWidth"
        :events="eventDates"
        :landscape="isLandscape"
      ></v-date-picker>
    </v-flex>
    <!-- <v-flex xs12 sm6 >
      <div class="title">Month news ({{ pickerDate || 'change month...' }})</div>
      <div class="subheading">Change month to see other news</div>
      <ul >
        <li v-for="note in notes" :key="note">{{ note }}</li>
      </ul>
    </v-flex> -->
  </v-layout>
</template>

<script>
import DashboardStore from '../../../stores/DashboardStore'

export default {
  data: () => ({
    date: null,
    pickerDate: null,
    notes: [],
    Events: DashboardStore.data.Events.data
  }),
  props: [
    'fullWidth',
    'landscape'
  ],
  watch: {
    pickerDate (val) {

    }
  },
  computed: {
    eventDates: function () {
      var d = []
      for (let i=0; i < this.Events.events.length; i++) {
        d.push(this.Events.events[i].date)
      }
      return d
    },
    isLandscape: function () {
      return this.landscape
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/layouts/dashboard/widgets/Calendar.vue